import { ApplicationConfig, APP_INITIALIZER, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors, withFetch } from '@angular/common/http';
import { provideLottieOptions } from 'ngx-lottie';

import { routes } from '@app/app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { authInterceptor } from '@app/interceptors/auth.interceptor';
import { PublicAuthService } from '@app/services/auth/public-auth/public-auth.service';

function restorePublicSession(publicAuthService: PublicAuthService): () => Promise<void> {
  return () => publicAuthService.restoreSessionFromServer();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
      }),
    ),
    provideClientHydration(withEventReplay()),
    provideHttpClient(withInterceptors([authInterceptor]), withFetch()),
    provideLottieOptions({
      player: () => import('lottie-web'),
    }),
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: restorePublicSession,
      deps: [PublicAuthService],
    },
  ],
};

